import { render, staticRenderFns } from "./AffiliateRevenueModal.vue?vue&type=template&id=af7a065e&"
import script from "./AffiliateRevenueModal.vue?vue&type=script&lang=babel&"
export * from "./AffiliateRevenueModal.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports